"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlansWithFeatureAvailable = void 0;
const isFeatureAvailable_1 = require("./isFeatureAvailable");
/**
 * Retrieve the list of plans that includes the given feature.
 *
 * @param plans The plans list to evaluate.
 * @param feature The feature availability to evaluate.
 * @returns The list of plans that includes the given feature.
 */
const getPlansWithFeatureAvailable = (plans, feature) => {
    if (!plans) {
        return [];
    }
    return plans.filter((plan) => (0, isFeatureAvailable_1.isFeatureAvailable)(plan, feature));
};
exports.getPlansWithFeatureAvailable = getPlansWithFeatureAvailable;
